export default "__VITE_ASSET__DSbOlMeW__"